import { API } from "./utils"

export const transactions = {
  transactionsList: (params = null) => API.get("/distributions/transactions/", { params }),
  getTransaction: (id) => API.get(`/distribution/transactions/${id}/`),
  exportTransactions: (data = null) => API.post("/distributions/transactions/export/", data),
}
